// =============================================================================
// SimSense Platform — Tauri Detection Hook
// =============================================================================
// Returns true if running inside Tauri WebView, false if in a regular browser.
// Consumes from useDesktopStore to ensure a single source of truth.

import { useDesktopStore } from "../state/desktopStore";

export function useTauri(): boolean {
  return useDesktopStore((state) => state.isTauri);
}
